import { Injectable } from '@angular/core';
//import { Http } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(private http: HttpClient) { }

  public uploadImage(file: File): Observable<any>{
    const formData = new FormData();
    formData.append('File', file);
    formData.append('ActivityId', '2938479234239874');
    //var response = this.http.post('http://52.11.130.203:8091/api/Activities', formData);
    var response = this.http.post('https://localhost:44340/api/activities', formData);
    return response;
  }

}
